import React, { useEffect, useState } from "react";

interface EllipsisProps {
    dotCount?: number;
    speedMs?: number;
    className?: string;
}

export const Ellipsis: React.FC<EllipsisProps> = ({ dotCount = 3, speedMs = 500, className }) => {
    const [dots, setDots] = useState(1);

    useEffect(() => {
        const id = setInterval(() => {
            setDots((prev) => (prev >= dotCount ? 1 : prev + 1));
        }, speedMs);

        return () => clearInterval(id);
    }, [dotCount, speedMs]);

    return (
        <span className={className}>{'.'.repeat(dots)}</span>
    );
};
